import { showToast } from '@/store/ui'

/**
 * Firestore applies a write locally at once and resolves its promise only
 * when the server acknowledges it, which offline may be much later. The
 * interface never waits for that; a refused write is reported here instead.
 */
export function reportWriteError(err: unknown): void {
  const code = (err as { code?: string }).code ?? ''
  const message = code === 'permission-denied' ? 'That change was not allowed.' : ((err as Error).message ?? 'Could not save that change.')
  console.error('write failed', err)
  showToast(message)
}

/** Fires a write without waiting for the server, reporting a refusal. */
export function fire(write: Promise<unknown>): void {
  write.catch(reportWriteError)
}
